const AGGREGATE_VARIABLES_URL = process.env.API_URL + '/aggregate-variables/';

const getAggregateVariables = (context) => {
  return context.$http.get(AGGREGATE_VARIABLES_URL);
};

const createAggregateVariable = (context, aggregateVariable) => {
  return context.$http.post(AGGREGATE_VARIABLES_URL, aggregateVariable);
};

const updateAggregateVariable = (context, aggregateVariable) => {
  return context.$http.put(AGGREGATE_VARIABLES_URL, aggregateVariable);
};

const deleteAggregateVariable = (context, id) => {
  return context.$http.delete(AGGREGATE_VARIABLES_URL, {params: {id: id}});
};

export default {
  getAggregateVariables,
  createAggregateVariable,
  updateAggregateVariable,
  deleteAggregateVariable
};



// WEBPACK FOOTER //
// ./src/api/aggregateVariables/aggregateVariablesHttp.js